import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { MenuOrderTreeComponent } from '../../shared/menu-order-tree/menu-order-tree.component';

@Component({
  selector: 'cwo-cart',
  standalone: true,
  imports: [CommonModule, MenuOrderTreeComponent, A11yModule],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
})
export class CartComponent {
 
}
